//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IInstagramDailyAudienceMetricsResponse } from '@apis/gateway-instagram/instagramAudienceMetricsModel';
import { IInstagramAudienceDailyMetrics } from '@instagram-account/models/IInstagramAudienceDailyMetrics';
import DateString from '@models/DateString';

export const HOURS_IN_DAY = Array.from({ length: 24 }, (v, k) => k);

export function parseInstagramDailyAudienceMetricsResponse(
  instagramDailyAudienceMetricsRequest: IInstagramDailyAudienceMetricsResponse,
): IInstagramAudienceDailyMetrics {
  return {
    ...instagramDailyAudienceMetricsRequest,
    dailyStats: instagramDailyAudienceMetricsRequest.dailyStats.map((dailyStat) => {
      const [year, month, day] = dailyStat.date;

      return {
        ...dailyStat,
        date: DateString(year, month, day),
      };
    }),
  };
}
